(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["buddy-mode-switcher"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('buddy-mode-switcher')) {
    customElements.define(
      'buddy-mode-switcher',
      class BuddyModeSwitcher extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-buddy-track]');
          this.cards = Array.from(this.querySelectorAll('[data-buddy-card]'));
          this.panels = Array.from(this.querySelectorAll('[data-buddy-panel]'));
          this.backgrounds = Array.from(this.querySelectorAll('[data-buddy-background]'));
          this.dots = Array.from(this.querySelectorAll('[data-buddy-dot]'));
          this.content = this.querySelector('[data-buddy-content]');
          this.mobileProduct = this.querySelector('[data-mobile-product]');
          this.mobileBuddies = Array.from(this.querySelectorAll('[data-mobile-buddy]'));
          this.mobileLabels = Array.from(this.querySelectorAll('[data-mobile-label]'));
          this.previousButtons = Array.from(this.querySelectorAll('[data-buddy-prev]'));
          this.nextButtons = Array.from(this.querySelectorAll('[data-buddy-next]'));
          this.isAutoplayEnabled = this.dataset.autoplay === 'true';
          this.autoplaySpeed = Number(this.dataset.autoplaySpeed) || 4000;
          this.pauseAfterClick = Number(this.dataset.pauseAfterClick) || 10000;
          this.currentIndex = Math.max(
            0,
            this.cards.findIndex((card) => card.classList.contains('is-active'))
          );
          this.intervalId = null;
          this.resumeTimeoutId = null;
          this.scrollTimeoutId = null;
          this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
          this.mobileQuery = window.matchMedia('(max-width: 749px)');
          this.hoverQuery = window.matchMedia('(min-width: 750px) and (hover: hover) and (pointer: fine)');

          this.handleCardClick = this.handleCardClick.bind(this);
          this.handleCardHover = this.handleCardHover.bind(this);
          this.handleDotClick = this.handleDotClick.bind(this);
          this.handlePreviousClick = this.handlePreviousClick.bind(this);
          this.handleNextClick = this.handleNextClick.bind(this);
          this.handleKeydown = this.handleKeydown.bind(this);
          this.handleScroll = this.handleScroll.bind(this);
          this.handleResize = this.handleResize.bind(this);
          this.handleBlockSelect = this.handleBlockSelect.bind(this);

          this.cards.forEach((card) => {
            card.addEventListener('click', this.handleCardClick);
            card.addEventListener('mouseenter', this.handleCardHover);
            card.addEventListener('keydown', this.handleKeydown);
          });

          this.dots.forEach((dot) => {
            dot.addEventListener('click', this.handleDotClick);
          });

          this.previousButtons.forEach((button) => {
            button.addEventListener('click', this.handlePreviousClick);
          });

          this.nextButtons.forEach((button) => {
            button.addEventListener('click', this.handleNextClick);
          });

          if (this.track) {
            this.track.addEventListener('scroll', this.handleScroll, { passive: true });
          }

          window.addEventListener('resize', this.handleResize);
          this.addEventListener('shopify:block:select', this.handleBlockSelect);

          this.selectCard(this.currentIndex);
          this.startAutoplay();
        }

        disconnectedCallback() {
          this.stopAutoplay();
          clearTimeout(this.resumeTimeoutId);
          clearTimeout(this.scrollTimeoutId);

          this.cards.forEach((card) => {
            card.removeEventListener('click', this.handleCardClick);
            card.removeEventListener('mouseenter', this.handleCardHover);
            card.removeEventListener('keydown', this.handleKeydown);
          });

          this.dots.forEach((dot) => {
            dot.removeEventListener('click', this.handleDotClick);
          });

          this.previousButtons.forEach((button) => {
            button.removeEventListener('click', this.handlePreviousClick);
          });

          this.nextButtons.forEach((button) => {
            button.removeEventListener('click', this.handleNextClick);
          });

          if (this.track) {
            this.track.removeEventListener('scroll', this.handleScroll);
          }

          window.removeEventListener('resize', this.handleResize);
          this.removeEventListener('shopify:block:select', this.handleBlockSelect);
        }

        handleCardClick(event) {
          this.selectCard(Number(event.currentTarget.dataset.index), { pause: true, center: true });
        }

        handleCardHover(event) {
          if (!this.hoverQuery.matches) {
            return;
          }

          this.selectCard(Number(event.currentTarget.dataset.index), { pause: true });
        }

        handleDotClick(event) {
          this.selectCard(Number(event.currentTarget.dataset.index), { pause: true, center: true });
        }

        handlePreviousClick() {
          this.selectCard((this.currentIndex - 1 + this.cards.length) % this.cards.length, { pause: true });
        }

        handleNextClick() {
          this.selectCard((this.currentIndex + 1) % this.cards.length, { pause: true });
        }

        handleKeydown(event) {
          if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft' && event.key !== 'Home' && event.key !== 'End') {
            return;
          }

          event.preventDefault();

          let nextIndex = this.currentIndex;

          if (event.key === 'ArrowRight') {
            nextIndex = (this.currentIndex + 1) % this.cards.length;
          }

          if (event.key === 'ArrowLeft') {
            nextIndex = (this.currentIndex - 1 + this.cards.length) % this.cards.length;
          }

          if (event.key === 'Home') {
            nextIndex = 0;
          }

          if (event.key === 'End') {
            nextIndex = this.cards.length - 1;
          }

          this.selectCard(nextIndex, { pause: true, center: true, focus: true });
        }

        handleScroll() {
          if (!this.mobileQuery.matches || !this.track) {
            return;
          }

          clearTimeout(this.scrollTimeoutId);
          this.scrollTimeoutId = setTimeout(() => {
            const nextIndex = this.getCenteredCardIndex();

            if (nextIndex !== this.currentIndex) {
              this.selectCard(nextIndex, { pause: true });
            }
          }, 110);
        }

        handleResize() {
          if (this.mobileQuery.matches) {
            this.centerCard(this.currentIndex);
          }
        }

        handleBlockSelect(event) {
          const selectedCard = event.target.closest('[data-buddy-card]');

          if (!selectedCard) {
            return;
          }

          this.selectCard(Number(selectedCard.dataset.index), { pause: true, center: true });
        }

        getCenteredCardIndex() {
          if (!this.track || !this.cards.length) {
            return this.currentIndex;
          }

          const trackRect = this.track.getBoundingClientRect();
          const trackCenter = trackRect.left + trackRect.width / 2;
          let closestIndex = this.currentIndex;
          let closestDistance = Infinity;

          this.cards.forEach((card, index) => {
            const cardRect = card.getBoundingClientRect();
            const cardCenter = cardRect.left + cardRect.width / 2;
            const distance = Math.abs(trackCenter - cardCenter);

            if (distance < closestDistance) {
              closestDistance = distance;
              closestIndex = index;
            }
          });

          return closestIndex;
        }

        selectCard(index, options = {}) {
          if (!this.cards.length || index < 0 || index >= this.cards.length) {
            return;
          }

          this.currentIndex = index;

          this.cards.forEach((card, cardIndex) => {
            const isActive = cardIndex === index;
            card.classList.toggle('is-active', isActive);
            card.setAttribute('aria-selected', String(isActive));
            card.setAttribute('tabindex', isActive ? '0' : '-1');
          });

          this.panels.forEach((panel, panelIndex) => {
            const isActive = panelIndex === index;
            panel.classList.toggle('is-active', isActive);
            panel.toggleAttribute('hidden', !isActive);
          });

          this.backgrounds.forEach((background, backgroundIndex) => {
            background.classList.toggle('is-active', backgroundIndex === index);
          });

          this.mobileBuddies.forEach((buddy, buddyIndex) => {
            buddy.classList.toggle('is-active', buddyIndex === index);
          });

          this.mobileLabels.forEach((label, labelIndex) => {
            label.classList.toggle('is-active', labelIndex === index);
          });

          this.dots.forEach((dot) => {
            const isActive = Number(dot.dataset.index) === index;
            dot.classList.toggle('is-active', isActive);
            dot.setAttribute('aria-current', String(isActive));
          });

          if (this.mobileProduct && this.cards[index]) {
            const accentColor = this.cards[index].style.getPropertyValue('--buddy-accent');
            this.mobileProduct.style.setProperty('--mobile-product-accent', accentColor);

            if (this.content) {
              this.content.style.setProperty('--buddy-accent', accentColor);
            }
          }

          if (options.center) {
            this.centerCard(index);
          }

          if (options.focus) {
            this.cards[index].focus();
          }

          if (options.pause) {
            this.pauseAutoplay();
          }
        }

        centerCard(index) {
          if (!this.mobileQuery.matches || !this.cards[index] || !this.track || this.track.offsetParent === null) {
            return;
          }

          this.cards[index].scrollIntoView({
            behavior: this.reducedMotion.matches ? 'auto' : 'smooth',
            block: 'nearest',
            inline: 'center'
          });
        }

        startAutoplay() {
          this.stopAutoplay();

          if (!this.isAutoplayEnabled || this.reducedMotion.matches || this.cards.length <= 1) {
            return;
          }

          this.intervalId = setInterval(() => {
            this.selectCard((this.currentIndex + 1) % this.cards.length, { center: true });
          }, this.autoplaySpeed);
        }

        stopAutoplay() {
          if (this.intervalId) {
            clearInterval(this.intervalId);
            this.intervalId = null;
          }
        }

        pauseAutoplay() {
          if (!this.isAutoplayEnabled || this.reducedMotion.matches) {
            return;
          }

          this.stopAutoplay();
          clearTimeout(this.resumeTimeoutId);
          this.resumeTimeoutId = setTimeout(() => this.startAutoplay(), this.pauseAfterClick);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
